'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = "@keyframes Spinner-module_spinAnimation__X2511{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.Spinner-module_spinner__GpFZS{animation-duration:1s;animation-iteration-count:infinite;animation-name:Spinner-module_spinAnimation__X2511;animation-timing-function:linear}";
var styles = {"spinner":"Spinner-module_spinner__GpFZS","spinAnimation":"Spinner-module_spinAnimation__X2511"};
styleInject["default"](css_248z, '550c4d7a-28a6-4791-84c7-332e28e10f20');

exports["default"] = styles;
